<ng-container
  *ngIf="
    hrefType === HrefType.ANGULAR_ROUTE ||
      hrefType === HrefType.EXTERNAL ||
      hrefType === HrefType.OPEN_MODAL_VIDEO;
    else noRouterLink
  "
>
  <!-- Special Links -->
  <a
    *ngIf="isSpecialLink(href) || inModal"
    class="special-link"
    [attr.href]="href"
    [attr.data-type]="type"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'nofollow'"
    [attr.target]="target"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="inModal"
      [iconName]="
        isPhoneLink(href) ? 'phone' : isEmailLink(href) ? 'envelope' : 'globe'
      "
      [color]="Colors.GREEN"
      [size]="Sizes.LARGE"
    ></hdi-icon>
    <div class="special-link__content">
      <span
        *ngIf="overLabel && isPhoneLink(href)"
        class="special-link__content__over-label"
        >{{ overLabel }}</span
      >
      <h5
        *ngIf="inModal; else outsideModal"
        class="special-link__content__label"
      >
        {{ isPhoneLink(href) ? label : overLabel }}
      </h5>
      <ng-template #outsideModal>
        <span
          class="special-link__content__label special-link__content__label--outside-modal"
          [innerHTML]="label"
        ></span>
      </ng-template>
    </div>
  </a>
  <!-- Angular Route Links -->
  <a
    *ngIf="
      hrefType === HrefType.ANGULAR_ROUTE && !isSpecialLink(href) && !inModal
    "
    [routerLink]="normalizeHref(href)"
    [fragment]="fragment && fragment.trim() !== '' ? fragment : undefined"
    [attr.data-type]="type"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || (fragment ? 'canonical' : 'follow')"
    [attr.target]="'_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
    <span
      [innerHTML]="label"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
  </a>
  <!-- External Links and Downloads-->
  <a
    *ngIf="hrefType === HrefType.EXTERNAL && !isSpecialLink(href) && !inModal"
    [attr.href]="!disabled ? normalizeHref(href) : '#'"
    [attr.data-type]="type"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'noopener noreferrer'"
    [attr.target]="'_blank'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <span
      [innerHTML]="label"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
  </a>
  <!-- Modal Links -->
  <a
    *ngIf="hrefType === HrefType.OPEN_MODAL_VIDEO"
    (click)="openModal($event)"
    [attr.data-type]="type"
    [attr.data-disabled]="disabled"
    [attr.rel]="'nofollow'"
    [attr.target]="'_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
    <span
      [innerHTML]="label"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
  </a>
</ng-container>

<!-- Navbar Links -->
<ng-template #noRouterLink>
  <a
    *ngIf="hrefType === HrefType.OPEN_FLYOUT"
    (click)="openFlyout.emit({ href: href, label: label })"
    [attr.data-type]="type"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'nofollow'"
    [attr.target]="target || '_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
    [innerHTML]="label"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
    <span [innerHTML]="label"></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
  </a>
</ng-template>
